import React from "react";
import { Phone, Smartphone } from "lucide-react";
import { howItWorks, esimSteps, PHONE, PHONE_TEL } from "../mock";

export const HowItWorks = () => (
  <section id="how-it-works" className="relative bg-[#1e183a] py-24 overflow-hidden">
    <div
      className="absolute inset-0 opacity-[0.06]"
      style={{
        backgroundImage:
          "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
        backgroundSize: "22px 22px",
      }}
    />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16">
      <div>
        <p className="reveal text-xs font-semibold tracking-[0.22em] uppercase text-[#7c3aed] mb-4">
          How It Works
        </p>
        <h2 className="reveal font-display text-4xl lg:text-5xl font-semibold text-white leading-tight">
          Three simple steps to sorted.
        </h2>
        <p className="reveal mt-6 text-white/60 leading-relaxed max-w-md">
          No jargon, no queues, no cost. Just clear, friendly help from real UK
          advisors &mdash; most issues solved in a single call.
        </p>
        <a
          href={`tel:${PHONE_TEL}`}
          className="reveal mt-8 inline-flex items-center gap-2.5 rounded-full bg-[#7c3aed] hover:bg-[#6d28d9] text-white font-semibold px-7 py-4 transition-all hover:-translate-y-0.5 cta-glow"
        >
          <Phone className="w-5 h-5" strokeWidth={2.5} /> Call {PHONE}
        </a>
      </div>

      <div className="space-y-10">
        {howItWorks.map((s, i) => (
          <div key={s.step} className="reveal flex gap-6 items-start">
            <span className="font-display text-6xl font-semibold text-transparent leading-none" style={{ WebkitTextStroke: "1.5px rgba(255,255,255,0.25)" }}>
              {s.step}
            </span>
            <div className={i < howItWorks.length - 1 ? "pb-10 border-b border-white/10 flex-1" : "flex-1"}>
              <h3 className="font-display text-2xl font-semibold text-white">{s.title}</h3>
              <p className="mt-2 text-white/60 leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ESim = () => (
  <section className="bg-[#f4f2fb] py-24">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <div>
          <p className="reveal flex items-center gap-2 text-xs font-semibold tracking-[0.22em] uppercase text-[#7c3aed] mb-4">
            <Smartphone className="w-4 h-4" /> eSIM Made Simple
          </p>
          <h2 className="reveal font-display text-4xl lg:text-5xl font-semibold text-[#1e183a] leading-tight">
            Activate your eSIM in four easy steps.
          </h2>
        </div>
        <a
          href={`tel:${PHONE_TEL}`}
          className="reveal inline-flex items-center gap-2.5 rounded-full bg-[#7c3aed] hover:bg-[#6d28d9] text-white font-semibold px-7 py-4 transition-all hover:-translate-y-0.5 cta-glow shrink-0"
        >
          <Phone className="w-5 h-5" strokeWidth={2.5} /> Stuck? Call us free
        </a>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {esimSteps.map((s) => (
          <div
            key={s.step}
            className="reveal rounded-3xl bg-white border border-[#1e183a]/8 p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-28px_rgba(19,26,51,0.4)]"
          >
            <span className="font-display text-5xl font-semibold text-[#7c3aed]/25">{s.step}</span>
            <h3 className="font-display text-xl font-semibold text-[#1e183a] mt-4">{s.title}</h3>
            <p className="mt-3 text-sm text-[#1e183a]/65 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
